import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, merge, startWith, switchMap } from 'rxjs';
import { DealService } from 'src/app/private/services/deals.service';
import { LeadService } from 'src/app/private/services/lead.service';
import { PipeLineService } from 'src/app/private/services/pipeline.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import {
  getLeadSourceImg as resolveLeadSourceImg,
  isLeadSourceImage,
} from 'src/app/utils/lead-source-icon.util';

@Component({
  selector: 'app-deals-report-details',
  templateUrl: './deals-report-details.component.html',
  styleUrls: ['./deals-report-details.component.scss']
})
export class DealsReportDetailsComponent {

  title = "Todays Leads";
  slug: string = '';

  reloading = false;
  isLoading = false;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 50];
  isDataLoading = false;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator)

  paginator!: MatPaginator;

  startDate: any = new Date();
  endDate: any = new Date();
  currencyCode: any = "₹";
  todaysFilter: any[] = [];

  monthStartDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  monthEndDate: any = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);


  isOpen = false;

  filterLoading = false;

  selecteTodayFilter: any = "Today";

  selecteLeadStatusFilter: any = {}

  selectedLeadStatusFilter: any[] = ["New"]

  selectedLeadSource: any[] = ["Tina"]

  selectedLeadOwnership: any[] = [];

  ownerList: any[] = [];

  selectedDealType: any[] = ["New Business"];

  defaultSetting = {
    singleSelection: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  leadWonerSetting = {
    singleSelection: false,
    idField: 'user_id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  dealTypeList: any[] = [
    "New Business",
    "Existing Business",
  ]




  leadSourceList: any[] = [
    "Channel Partner",
    "Conference",
    "Field Visit",
    "Google",
    "Instagram",
    "Lead Gen Tools",
    "Live Session",
    "Personal",
    "Referral",
    "LinkedIn",
    "Website",
    "WhatsApp",
    "Tina",
    "Intern",
    "Other"
  ]





  displayedColumns: string[] = [
    "deal_name",
    "amount",
    "deal_owner",
    "lead_source",
    "createdAt",
    "account_name",
    "close_date",
    "probability",
    "deal_stage",
    "deal_type",
    "deal_priority",
  ];

  pipeline_id: any;
  selectedDealStages: any[] = [];
  dealStages: any[] = [];
  pipelineData: any[] = [];
  pipelines: any[] = [];
  isAdmin: boolean = false;



  initialLoad = true;
  constructor(private route: ActivatedRoute,
    private api: DealService,
    private localStorage: LocalStorageService,
    private userService: UsersService,
    private pipelineApi: PipeLineService,
    private toaster: ToastrService
  ) {
    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  // Maps each report slug to the column that the report is about, so it can be
  // surfaced as the first column of the table.
  private readonly primaryColumnBySlug: { [slug: string]: string } = {
    'deal-type-report': 'deal_type',
    'sales-by-lead-source': 'lead_source',
    'pipeline-by-stage': 'deal_stage',
    'sales-by-user': 'deal_owner',
    'open-deals': 'deal_stage',
    'closed-deals': 'deal_stage',
    'lost-deals': 'deal_stage',
    'deals-closing-this-month': 'close_date',
  };

  private applyPrimaryColumnOrder(): void {
    const primaryColumn = this.primaryColumnBySlug[this.slug];
    if (!primaryColumn) {
      return;
    }
    const columns = [...this.displayedColumns];
    const primaryIndex = columns.indexOf(primaryColumn);
    if (primaryIndex === -1) {
      return;
    }
    columns.splice(primaryIndex, 1);
    columns.unshift(primaryColumn);
    this.displayedColumns = columns;
  }

  ngAfterViewInit(): void {
    this.route.paramMap.subscribe(params => {
      this.slug = params.get('slug') || '';
    });

    this.currencyCode = this.localStorage.getClientCurrency();

    switch (this.slug) {

      case 'todays-sales':
        this.title = "Today's Sales";
        this.getTodaysSales();
        break;
      case 'deal-type-report':
        this.title = "Deal Type Report";
        this.getDealTypeReport();
        break;
      case 'sales-by-lead-source':
        this.title = "Sales by Lead Source";
        this.getSalesByLeadSource();
        break;
      case 'pipeline-by-stage':
        this.title = "Pipeline by Stage";
        this.getAllPipeline();
        // this.getPipelineByStage();
        break;
      case 'sales-by-user':
        this.title = "Sales by User";
        this.selectedLeadOwnership = [
          {
            user_id: this.localStorage.getUserId(),
            name: `${this.localStorage.getFirstName()} ${this.localStorage.getLastName()}`
          }
        ];
        this.getAllLeadOwners();
        this.getDealsByUser();
        break;
      case 'open-deals':
        this.title = "Open Deals";
        this.getOpenDeals();
        break;
      case 'closed-deals':
        this.title = "Closed Deals";
        this.getCloseDeals();
        break;
      case 'lost-deals':
        this.title = "Lost Deals";
        this.getLostDeals();
        break;

      case 'deals-closing-this-month':
        this.title = "Deals Closing this Month";
        this.getDealsClosingThisMonth();
        break;

    }

    this.applyPrimaryColumnOrder();


    const today = new Date();
    const day = 24 * 60 * 60 * 1000; // one day in milliseconds
    const startOfWeek = (date: Date) => {
      const d = new Date(date);
      const diff = d.getDate() - d.getDay(); // Sunday as start of week
      return new Date(d.setDate(diff));
    };
    const endOfWeek = (date: Date) => {
      const d = startOfWeek(date);
      return new Date(d.getTime() + 6 * day);
    };
    const startOfMonth = (date: Date) => new Date(date.getFullYear(), date.getMonth(), 1);
    const endOfMonth = (date: Date) => new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const startOfQuarter = (date: Date) => new Date(date.getFullYear(), Math.floor(date.getMonth() / 3) * 3, 1);
    const endOfQuarter = (date: Date) => new Date(date.getFullYear(), Math.floor(date.getMonth() / 3) * 3 + 3, 0);
    const startOfYear = (date: Date) => new Date(date.getFullYear(), 0, 1);
    const endOfYear = (date: Date) => new Date(date.getFullYear(), 11, 31);

    const addDays = (date: Date, days: number) => new Date(date.getTime() + days * day);

    this.todaysFilter = [
      { label: "Today", value: "today", start_date: today, end_date: today },
      { label: "Yesterday", value: "yesterday", start_date: addDays(today, -1), end_date: addDays(today, -1) },
      { label: "Last 3 Days", value: "last_3_days", start_date: addDays(today, -2), end_date: today },
      { label: "Last 7 Days", value: "last_7_days", start_date: addDays(today, -6), end_date: today },
      { label: "Last 14 Days", value: "last_14_days", start_date: addDays(today, -13), end_date: today },
      { label: "Last 21 Days", value: "last_21_days", start_date: addDays(today, -20), end_date: today },
      { label: "Last 30 Days", value: "last_30_days", start_date: addDays(today, -29), end_date: today },
      { label: "This Week", value: "this_week", start_date: startOfWeek(today), end_date: endOfWeek(today) },
      { label: "Last Week", value: "last_week", start_date: addDays(startOfWeek(today), -7), end_date: addDays(endOfWeek(today), -7) },
      { label: "This Quarter", value: "this_quarter", start_date: startOfQuarter(today), end_date: endOfQuarter(today) },
      { label: "Last Quarter", value: "last_quarter", start_date: addDays(startOfQuarter(today), -90), end_date: addDays(startOfQuarter(today), -1) },
      { label: "This Month", value: "this_month", start_date: startOfMonth(today), end_date: endOfMonth(today) },
      { label: "Last Month", value: "last_month", start_date: new Date(today.getFullYear(), today.getMonth() - 1, 1), end_date: new Date(today.getFullYear(), today.getMonth(), 0) },
      { label: "This Year", value: "this_year", start_date: startOfYear(today), end_date: endOfYear(today) },
      { label: "Last Year", value: "last_year", start_date: new Date(today.getFullYear() - 1, 0, 1), end_date: new Date(today.getFullYear() - 1, 11, 31) },
    ];



  }


  getAllPipeline() {
    let param = {
      client_id: this.localStorage.getClientId(),
      pipeline_type: 'deal',
    };
    this.pipelineApi.getAllPipeLine(param).subscribe({
      next: (res: any) => {
        this.pipelineData = res || [];

        this.pipelines = this.pipelineData.map((item: any) => item.pipeline_name);

        this.pipeline_id = this.pipelines[0];

        this.dealStages = this.pipelineData[0].stages?.map((item: any) => item.stage_name);

        this.selectedDealStages = this.dealStages;

        this.getPipelineByStage();


      },
      error: (e: any) => {
        this.toaster.error("Error fetching pipelines", "Error");
        console.error(e);
      },
    });
  }


  getAllLeadOwners() {
    try {

      let param = {
        client_id: this.localStorage.getClientId(),
      };

      this.userService.findAllUsers(param).subscribe({
        next: (data) => {
          this.ownerList = data;

          this.ownerList = this.ownerList.map((owner: any) => {
            return {
              user_id: owner.user_id,
              name: `${owner.fname} ${owner.lname}`,
            };
          });
        },
        error: (e) => {
          console.error(e);
        },
        complete: () => { },
      });
    } catch (e) {
      console.error(e);
    }
  }



  getTodaysSales() {

    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;

            console.log("client_id", this.localStorage.getClientId())
            let param : any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
              },
              "startDate": this.startDate,
              "endDate": this.endDate,
              "order": {
                "col": "\"deal\".\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (!this.isAdmin) {
              param.where.deal_owner = this.localStorage.getUserId();
            }

            return this.api
              .getAllDeal(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            console.log("response", response.length)
            return response?.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }

  getDealTypeReport() {
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;

            console.log("client_id", this.localStorage.getClientId())
            let param : any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
                "deal_type": this.selectedDealType,
              },
              "order": {
                "col": "\"deal\".\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (!this.isAdmin) {
              param.where.deal_owner = this.localStorage.getUserId();
            }

            return this.api
              .getAllDeal(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            console.log("response", response.length)
            return response?.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }

  getSalesByLeadSource() {
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;

            console.log("client_id", this.localStorage.getClientId())
            let param : any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
                "lead_source": this.selectedLeadSource,
              },
              "order": {
                "col": "\"deal\".\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (!this.isAdmin) {
              param.where.deal_owner = this.localStorage.getUserId();
            }

            return this.api
              .getAllDeal(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            console.log("response", response.length)
            return response?.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }

  getPipelineByStage() {
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;

            console.log("client_id", this.localStorage.getClientId())
            let param : any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
                // "pipeline_id": this.pipeline_id,
                "deal_stage": this.selectedDealStages
              },
              "order": {
                "col": "\"deal\".\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (!this.isAdmin) {
              param.where.deal_owner = this.localStorage.getUserId();
            }

            return this.api
              .getAllDeal(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            console.log("response", response.length)
            return response?.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }

  getDealsByUser() {
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;

            console.log("client_id", this.localStorage.getClientId())
            let param : any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
                "deal_owner": this.selectedLeadOwnership?.map((item: any) => item.user_id)
              },
              "order": {
                "col": "\"deal\".\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (!this.isAdmin) {
              param.where.deal_owner = this.localStorage.getUserId();
            }
            
            return this.api
              .getAllDeal(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            console.log("response", response.length)
            return response?.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }


  getOpenDeals() {
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;

            console.log("client_id", this.localStorage.getClientId())
            let param : any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
                "deal_stage": this.selectedDealStages
              },
              "order": {
                "col": "\"deal\".\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (!this.isAdmin) {
              param.where.deal_owner = this.localStorage.getUserId();
            }

            return this.api
              .getAllDeal(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            console.log("response", response.length)
            return response?.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }

  getLostDeals() {
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;

            console.log("client_id", this.localStorage.getClientId())
            let param : any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
                "deal_stage": "Closed Lost"
              },
              "order": {
                "col": "\"deal\".\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (!this.isAdmin) {
              param.where.deal_owner = this.localStorage.getUserId();
            }

            return this.api
              .getAllDeal(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            console.log("response", response.length)
            return response?.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }

  getDealsClosingThisMonth() {
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;

            console.log("client_id", this.localStorage.getClientId())
            let param : any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
                "startDate": this.monthStartDate,
                "endDate": this.monthEndDate,
              },
              "order": {
                "col": "\"deal\".\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (!this.isAdmin) {
              param.where.deal_owner = this.localStorage.getUserId();
            }

            return this.api
              .getAllDeal(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            console.log("response", response.length)
            return response?.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }


  getCloseDeals() {
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;

            console.log("client_id", this.localStorage.getClientId())
            let param : any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
                "deal_stage": "Closed Won"
              },
              "order": {
                "col": "\"deal\".\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (!this.isAdmin) {
              param.where.deal_owner = this.localStorage.getUserId();
            }

            return this.api
              .getAllDeal(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            console.log("response", response.length)
            return response?.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }




  onTodaysFilterChange(event: any) {
    let selectedFilter = this.todaysFilter.find((filter) => filter.label === event);
    console.log(selectedFilter);
    this.startDate = selectedFilter.start_date;
    this.endDate = selectedFilter.end_date;
  }

  onFilterChange(event: any) {
    this.selecteLeadStatusFilter = event;
    this.onTodaysFilterChange(this.selecteTodayFilter);
  }



  isSourceImage(source: string) {
    return isLeadSourceImage(source);
  }

  getLeadSourceImg(source: string) {
    return resolveLeadSourceImg(source);
  }

  openBulkFilter() {
    this.isOpen = true;
  }

  closeSidebar() {
    this.isOpen = false;
  }

  applyBulkFilter() {
    this.isOpen = false;

    if (this.slug == 'todays-sales') {
      this.getTodaysSales();
    } else if (this.slug == 'deal-type-report') {
      this.getDealTypeReport();
    }
    else if (this.slug == 'sales-by-lead-source') {
      this.getSalesByLeadSource();
    }
    else if (this.slug == 'pipeline-by-stage') {
      this.getPipelineByStage();
    }
    else if (this.slug == 'sales-by-user') {
      this.getDealsByUser();
    }
    else if (this.slug == 'open-deals') {
      this.getOpenDeals();
    }
    else if (this.slug == 'lost-deals') {
      this.getLostDeals();
    }

    else if (this.slug == 'deals-closing-this-month') {
      this.getDealsClosingThisMonth();
    }

  }
  clearFilter() {
    this.isOpen = false;
  }

  getOwnerName(owner: any) {
    if (owner && owner.fname && owner.lname) {
      return `${owner.fname} ${owner.lname}`;
    } else if (owner && owner.fname) {
      return owner.fname;
    } else if (owner && owner.lname) {
      return owner.lname;
    } else {
      return 'N/A';
    }
  }

  getDealStages(e: any): void {
    const pipelineId = e.target.value;
    console.log('pipelineId', e?.target?.value);
    console.log('pipelineData', this.pipelineData);

    let stages = this.pipelineData.filter((item: any) => item.pipeline_name === pipelineId);
    console.log('stages', stages);
    if (stages.length > 0) {
      this.dealStages = stages[0].stages;
    }
  }


}


function observableOf(arg0: null): any {
  console.log(arg0);
  throw new Error('Function not implemented.');
}